import { Service } from "./service"

export const RoleService = Service


// WEBPACK FOOTER //
// ./src/role/services/index.ts